import { Search } from "lucide-react";
import { MEETING_STATUSES, STATUSES } from "@/lib/constants";

export const EMPTY_FILTERS = { q: "", status: "", setter: "", closer: "", source: "", meeting: "", flagged: false, flagType: "", from: "", to: "" };
const FLAG_TYPES = [{ value: "aging", label: "Aging" }, { value: "booking-lag", label: "Booking lag" }, { value: "deposit-unpaid", label: "Deposit unpaid" }];

const Sel = ({ value, onChange, testid, label, options }) => (
  <select data-testid={testid} value={value} onChange={onChange} className="inp" aria-label={label}>
    <option value="">{`${label}: All`}</option>
    {options.map((o) => (typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>))}
  </select>
);

export const LogFilters = ({ filters, setFilters, reps, sources }) => {
  const set = (k) => (e) => setFilters((f) => ({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const repOpts = reps.map((r) => ({ value: r.id, label: r.active ? r.name : `${r.name} (inactive)` }));
  const active = JSON.stringify(filters) !== JSON.stringify(EMPTY_FILTERS);
  return (
    <div className="space-y-3 rounded-2xl border border-slate-800 bg-slate-900 p-4" data-testid="lead-log-filters">
      <div className="relative">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
        <input data-testid="lead-log-search-input" value={filters.q} onChange={set("q")} placeholder="Search name, company, email, phone…" className="inp pl-9" />
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4 xl:grid-cols-7">
        <Sel testid="lead-log-filter-status" label="Status" value={filters.status} onChange={set("status")} options={STATUSES} />
        <Sel testid="lead-log-filter-setter" label="Setter" value={filters.setter} onChange={set("setter")} options={repOpts.filter((o) => ["Setter", "Both"].includes(reps.find((r) => r.id === o.value).role))} />
        <Sel testid="lead-log-filter-closer" label="Closer" value={filters.closer} onChange={set("closer")} options={repOpts.filter((o) => ["Closer", "Both"].includes(reps.find((r) => r.id === o.value).role))} />
        <Sel testid="lead-log-filter-source" label="Source" value={filters.source} onChange={set("source")} options={sources} />
        <Sel testid="lead-log-filter-meeting-status" label="Meeting" value={filters.meeting} onChange={set("meeting")} options={MEETING_STATUSES} />
        <Sel testid="lead-log-filter-flag-type" label="Flag" value={filters.flagType} onChange={set("flagType")} options={FLAG_TYPES} />
        <label className="flex h-10 cursor-pointer items-center gap-2 rounded-lg border border-slate-800 px-3 text-sm">
          <input type="checkbox" data-testid="lead-log-filter-flagged" checked={filters.flagged} onChange={set("flagged")} className="h-4 w-4 accent-indigo-600" />
          Flagged only
        </label>
      </div>
      <div className="flex flex-wrap items-end gap-2">
        <label className="text-xs text-slate-400">Created from
          <input type="date" data-testid="lead-log-filter-from" value={filters.from} onChange={set("from")} className="inp mt-1 w-40" />
        </label>
        <label className="text-xs text-slate-400">to
          <input type="date" data-testid="lead-log-filter-to" value={filters.to} onChange={set("to")} className="inp mt-1 w-40" />
        </label>
        {active && <button type="button" data-testid="lead-log-clear-filters-btn" onClick={() => setFilters(EMPTY_FILTERS)} className="btn-ghost">Clear filters</button>}
      </div>
    </div>
  );
};
